module.exports = __webpack_public_path__ + "static/media/8.42fbd46c.JPG";